import { tiers } from "../../constants/tier";
import { IconCheck } from "@tabler/icons-react";

export function PricingTable({ pricing }) {
  const CheckIcon = () => {
    return (
      <IconCheck className="mx-auto h-4 w-4 flex-shrink-0 text-black dark:text-white" />
    );
  };

  const tableFeatures = [
    {
      title: "Sites",
      free: "",
      popular: "1",
      pro: "3",
      expert: "10",
    },
    {
      title: "Basic Products Table",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Quick variations edit",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Adding new product",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Basic filter",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Search per product, SKU and more",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Smart Gallery - Single and Multiple Pics",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Store view",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Themes",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Switch between Whizmanage and WordPress admin freely",
      free: <CheckIcon />,
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Full support",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Add product variations",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Add new product, including features",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Drag & drop columns",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Edit All - Like in spreadsheets",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Bulk editing",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Add and edit customized fields",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Full support",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Personalized columns",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "Advanced filters",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
    {
      title: "New features",
      free: "",
      popular: <CheckIcon />,
      pro: <CheckIcon />,
      expert: <CheckIcon />,
    },
  ];

  return (
    <>
    <div className="mx-auto w-full relative z-20 px-4 py-4 md:py-10 dark hidden md:block" data-aos="fade-up">
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-800/50">
              <thead className="">
                <tr>
                  <th
                    scope="col"
                    className="max-w-xs py-3.5 pl-4 pr-3 text-left text-3xl font-extrabold text-neutral-900 dark:text-white sm:pl-0"
                  ></th>
                  {tiers?.map((item, index) => (
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-center text-lg font-semibold text-neutral-900 dark:text-white"
                      key={`pricing-${index}`}
                    >
                      {item.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-neutral-800/50">
                {tableFeatures.map((feature) => (
                  <tr key={feature.title} className="hover:bg-neutral-900/40 pl-4">
                    <td className="whitespace-nowrap p-4 !pl-4 text-sm font-medium text-neutral-900 dark:text-white sm:pl-0">
                      {feature.title}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-muted dark:text-muted-dark text-center">
                      {feature.free}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-muted dark:text-muted-dark text-center">
                      {feature.popular}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-muted dark:text-muted-dark text-center">
                      {feature.pro}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-muted dark:text-muted-dark text-center">
                      {feature.expert}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* <FreeTrial /> */}
      </div>
    </div>
    <div className="mx-auto w-full relative z-20 px-4 py-4 md:py-10 dark md:hidden">
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-800/50">
              <thead className="">
                <tr>
                  <th
                    scope="col"
                    className="max-w-xs py-3.5 pl-4 pr-3 text-left text-3xl font-extrabold text-neutral-900 dark:text-white sm:pl-0"
                  ></th>
                  {tiers?.map((item, index) => (
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-center text-lg font-semibold text-neutral-900 dark:text-white"
                      key={`pricing-${index}`}
                    >
                      {item.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-neutral-800/50">
                {tableFeatures.map((feature) => (
                  <tr key={feature.title} className="hover:bg-neutral-900/40 pl-4">
                    <td className="whitespace-nowrap p-4 !pl-4 text-sm font-medium text-neutral-900 dark:text-white sm:pl-0">
                      {feature.title}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-muted dark:text-muted-dark text-center">
                      {feature.free}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-muted dark:text-muted-dark text-center">
                      {feature.popular}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-muted dark:text-muted-dark text-center">
                      {feature.pro}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-muted dark:text-muted-dark text-center">
                      {feature.expert}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* <FreeTrial /> */}
      </div>
    </div>
    </>
  );
}
